import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import { PagedMenuContext } from "./PagedMenuContext";

import { DirectionButton } from "../DirectionButton";

const PagingControl = forwardRef(
  ({ direction, targetPage, small, children }, ref) => {
    const { changePage } = useContext(PagedMenuContext);
    return (
      <DirectionButton
        ref={ref}
        small={small}
        direction={direction}
        onClick={() => {
          changePage(targetPage);
        }}
      >
        {children}
      </DirectionButton>
    );
  }
);

PagingControl.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  targetPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  small: PropTypes.bool,
  direction: PropTypes.oneOf(["backward", "forward"]).isRequired,
};

PagingControl.defaultProps = {
  small: false,
};

PagingControl.displayName = "PagedMenuPagingControl";

export default PagingControl;
